import Resizer from 'react-image-file-resizer';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const useStorage = () => {
    const storage = getStorage();

    const compressImage = async (file) => {
        return new Promise((resolve) => {
            Resizer.imageFileResizer(file,1920,1080,"JPEG",70,0,(uri) => {resolve(uri)},'blob')
        })
    }

    const makeBlob = async (file) => {
        const blob = await compressImage(file)
        return blob
    }

    const uploadToStorage = async (folder, name, file) => {
        const blob = await makeBlob(file)
        const fileRef = ref(storage, `${folder}/${name}`)
        const snapshot = await uploadBytes(fileRef, blob);
        const url = await getDownloadURL(snapshot.ref)
        return url
        
    }


    return { uploadToStorage }

}

export default useStorage